import { useContext } from "react";
import { motion } from "framer-motion";
import { dataContext } from "../../context/context";
import './header.css';
import logo from "../../assets/images/logo-wide.svg";

function HeaderDesktop() {

    const { data  } = useContext(dataContext);


return (
        <motion.header

            initial={{ opacity: 0, y: -100, }}
            animate={{ opacity: 1, y: 0  }}
            transition={{ duration: 1 }}

        >
            <div className="header__inner">
            <div className="logo"><a href="/"><img alt="студия Феникс - разработка сйтов и мобильных приложений в Калининграде" src={logo} /></a></div>
            <ul><nav>
                {

                data.sectionsdata.map(section => (
                    <li key={section.id}>
                        <a key={section.id} href={`/#${section.nick}`}>
                            {section.name}
                        </a>
                    </li>
                ))
                }
            </nav></ul>
                <div className="phones">
                    {
                        data.variablesdata.filter(variable => variable.var === 'phone').map((phone, index) => (
                            <a key={index} href={`tel: ${phone.clearedval}`}>{phone.val}</a>
                        ))
                    }
                </div>

            </div>
        </motion.header>
    )
}

export default HeaderDesktop;